import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function FireSM(): React.ReactElement {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.06185 11.9998C2.72791 7.60432 5.54649 5.9994 5.54649 5.9994C5.34928 8.34489 6.68217 10.1722 6.68217 10.1722C7.17239 10.0243 8.10807 9.33302 8.10807 9.33302C8.10807 10.1722 7.61435 11.9988 7.61435 11.9988C7.61435 11.9988 9.3427 10.6624 9.88677 8.4428C10.4301 6.22318 8.85178 3.99482 8.85178 3.99482C8.94689 5.56583 8.41541 7.11096 7.37414 8.2914C7.42624 8.23125 7.46994 8.16447 7.50351 8.09209C7.69058 7.71796 7.99093 6.74557 7.81505 4.49378C7.5675 1.33289 4.70347 0 4.70347 0C4.95032 1.92591 4.2101 2.36962 2.47616 6.02527C0.742213 9.68023 4.06185 11.9998 4.06185 11.9998Z" />
    </svg>
  );
}
